import React, { useState, useEffect } from 'react';
import './Card.css';
import CardInfoOverlay from './CardInfoOverlay';
import { useImageSource } from '../../../contexts/ImageSourceContext';
import { getSetName } from '../../../utils/sets';

function CondensedTradeCard({ card, entry, onDelete, onAnyFinishClick, isHighlighted = false }) {
    const { getImageUrl } = useImageSource();
    const [showInfo, setShowInfo] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [setDisplayName, setSetDisplayName] = useState(card?.setCode || '');
    const [prices, setPrices] = useState(entry?.prices || {});

    useEffect(() => {
        // Set name from the shared, fetched-once list
        let alive = true;
        getSetName(card?.setCode).then(name => { if (alive) setSetDisplayName(name || card?.setCode || ''); });
        return () => { alive = false; };
    }, [card?.setCode]);

    useEffect(() => {
        // Fetch prices if not provided
        async function fetchPrices() {
            if (!card?.uuid) return;
            try {
                const url = card.setCode
                    ? `/api/card-prices/${card.uuid}?setCode=${card.setCode}`
                    : `/api/card-prices/${card.uuid}`;
                const response = await fetch(url);
                if (response.ok) {
                    const priceData = await response.json();
                    setPrices(priceData);
                }
            } catch { }
        }
        if (!entry?.prices && card?.uuid) fetchPrices();
    }, [card?.uuid, card?.setCode, entry?.prices]);

    // Price display logic
    let price = null;
    if (entry?.finish === 'any') {
        price = null;
    } else if (entry?.finish && prices && prices[entry.finish]) {
        price = prices[entry.finish].usd_price;
    } else if (prices && Object.values(prices)[0]) {
        const p = Object.values(prices)[0];
        price = p.usd_price;
    }

    return (
        <div className={`condensed-trade-card condensed-trade-card-large ${isHighlighted ? 'card-highlighted' : ''}`}>
            <div className="condensed-trade-card-img-wrap condensed-trade-card-img-wrap-large">
                {getImageUrl(card) && !imageError ? (
                    <div style={{ position: 'relative' }}>
                        <img
                            src={getImageUrl(card)}
                            alt={card.name}
                            className="condensed-trade-card-img condensed-trade-card-img-large"
                            onError={() => setImageError(true)}
                        />
                        {entry?.finish === 'any' && onAnyFinishClick && (
                            <button
                                className="any-finish-card-btn"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onAnyFinishClick(card.name);
                                }}
                                aria-label={`Search for ${card.name} finishes`}
                                title={`Search for ${card.name} finishes`}
                            >
                                +
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="condensed-trade-card-img-placeholder condensed-trade-card-img-large">?</div>
                )}
            </div>
            <div className="condensed-trade-card-price condensed-trade-card-price-large">{price ? `$${price}` : 'N/A'}</div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 4, justifyContent: 'center', alignItems: 'center', marginTop: 2 }}>
                <button
                    className="condensed-trade-card-info-btn condensed-trade-card-info-btn-large"
                    onClick={e => { e.stopPropagation(); setShowInfo(true); }}
                    aria-label="Card Information"
                >
                    i
                </button>
                <button
                    className="condensed-trade-card-delete-btn condensed-trade-card-info-btn-large"
                    onClick={e => { e.stopPropagation(); if (onDelete) onDelete(); }}
                    aria-label="Remove from Trade"
                >
                    ×
                </button>
            </div>
            <CardInfoOverlay
                show={showInfo}
                card={card}
                entry={entry}
                prices={prices}
                setDisplayName={setDisplayName}
                imageError={imageError}
                onClose={() => setShowInfo(false)}
                onImageError={() => setImageError(true)}
            />
        </div>
    );
}

export default CondensedTradeCard;
